import * as React from "react";
import { Menu } from "@material-ui/core";
import PropTypes from "prop-types";
import { FiMoreVertical } from "react-icons/fi";

const AnchorMenu = ({ anchorRender, iconRender, customWidth }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <span
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
       {iconRender ? iconRender : <FiMoreVertical style={{ cursor: "pointer" }} />} 
      </span>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            width: customWidth || "15ch",
            marginTop: "1.5rem",
            borderRadius: "12px"
          },
        }}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {anchorRender()}
      </Menu>
    </div>
  );
};

AnchorMenu.propTypes = {
   anchorRender: PropTypes.func.isRequired,
  };

export default AnchorMenu;
